module.exports = __webpack_public_path__ + "static/media/order.b2bd0445.svg";